var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.70711 11.8738C8.31658 11.4832 8.31658 10.8501 8.70711 10.4596L11.4596 7.70711C11.8501 7.31658 12.4832 7.31658 12.8738 7.70711L22.2929 17.1262C22.6834 17.5168 23.3166 17.5168 23.7071 17.1262L33.1262 7.70711C33.5168 7.31658 34.1499 7.31658 34.5404 7.70711L37.2929 10.4596C37.6834 10.8501 37.6834 11.4832 37.2929 11.8738L27.8738 21.2929C27.4832 21.6834 27.4832 22.3166 27.8738 22.7071L37.2929 32.1262C37.6834 32.5168 37.6834 33.1499 37.2929 33.5404L34.5404 36.2929C34.1499 36.6834 33.5168 36.6834 33.1262 36.2929L23.7071 26.8738C23.3166 26.4832 22.6834 26.4832 22.2929 26.8738L12.8738 36.2929C12.4832 36.6834 11.8501 36.6834 11.4596 36.2929L8.70711 33.5404C8.31658 33.1499 8.31658 32.5168 8.70711 32.1262L18.1262 22.7071C18.5168 22.3166 18.5168 21.6834 18.1262 21.2929L8.70711 11.8738Z",
    fill: "#958060",
    stroke: "#958060",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/closeIcon.d964dd2d862520aab28f64664b2fd562.svg";
export { ForwardRef as ReactComponent };